import React, { useState, useEffect, useMemo, Fragment } from "react";
import { Card, Row, Col, Spinner, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import TanstackTable from "components/elements/advance-table/TanstackTable";
import CommonHeader from "layouts/dashboard/CommonHeader";
import quizIcon from "../../assets/images/Quiz_illustration 1.svg";
import { getAssessment } from "ServerAPI/serverAPI";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

const AttemptsBadge = ({ attempts }) => {
  let bgValue = '';
  if (attempts >= 6) {
    bgValue = 'danger-soft'; 
  } else if (attempts >= 4) {
    bgValue = 'warning-soft'; 
  } else {
    bgValue = 'success-soft'; 
  }

  return <Badge bg={bgValue}>{attempts}</Badge>;
};

const AssessmentReviewTable = ({ email, userId }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [cookies, setCookies] = useCookies();
  const navigate = useNavigate(); 

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getAssessment(cookies.email, cookies.userId);
        if (response && response.data) {
          const formattedData = response.data.map(item => ({
            quizTitle: item.assessmentName,
            attempts: item.numberOfAttempts,
            correct: item.totalRightQuestions,
            incorrect: item.totalWrongQuestions,
            marks: item.totalPercentage,
            passingMarks: item.passingPercentage,
            sectionId: item.sectionId,
            contentId:item.contentId,
            courseId: item.courseId
          }));
          setData(formattedData);
        } else {
          setData([]);
        }
      } catch (error) {
        console.error("Error loading assessment data:", error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [email, userId]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "quizTitle",
        header: "Assessment Name",
        width: "30%",
      },
      { accessorKey: "correct", header: "Correct Answers", width: "10%" },
      { accessorKey: "incorrect", header: "Incorrect Answers", width: "10%" },
      {
        accessorKey: "attempts",
        header: "No. Of Attempts",
        width: "10%",
        cell: ({ cell }) => <AttemptsBadge attempts={cell.getValue()} />,
      },
      {
        accessorKey: "passingMarks",
        header: "Passing Percentage (%)",
        width: "10%",
      },
      {
        accessorKey: "marks",
        header: "Obtained Percentage (%)",
        width: "10%",
      },
      {
        accessorKey: "retakeQuiz",
        header: "Retake Quiz",
        width: "10%",
        cell: ({ row }) => (
          <button
            className="btn btn-primary btn-sm"
            onClick={() =>
              navigate(
                `/view-course/${row.original.courseId}/${row.original.sectionId}/${row.original.contentId}`,
                { state: { retakeQuiz: true,reviewQuiz: true } })
            }
          >
            Retake
          </button>
        ),
      }
      
    ],
    []
  );

  return (
    <Fragment>
      <Row>
        <Col>
          <CommonHeader
            text="My Assessment Attempt"
            subText="You can find all of your assessment attempts here."
            icon={quizIcon}
          />
        </Col>
      </Row>

      <Row className="mx-auto">
        <Col sm={10} className="mx-auto pt-5 px-0">
          <Card>
            <Card.Body className="p-0">
              {loading ? (
                <div className="text-center p-4">
                  <Spinner animation="border" />
                </div>
              ) : (
                <TanstackTable data={data} columns={columns} pagination={true} />
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default AssessmentReviewTable;
